import countries from "../../data/world-countries-sans-antarctica.json";
import "./Choropleth.scss";
import * as d3 from "d3";
import { geoCylindricalStereographic } from "d3-geo-projection";
import { useEffect, useRef, useState } from "react";
import * as topojson from "topojson-client";
import { appendOnce } from "../../utils/appendOnce";
import keyBy from "lodash/groupBy";
export function Choropleth({ data }) {
	const svgRef = useRef();
	const width = 800;
	const height = 462;
	const [colorBands, setColorBands] = useState(null);

	useEffect(() => {
		let groupedData = keyBy(data.data, "country");
		const svg = d3.select(svgRef.current);

		let mapData = topojson.feature(countries, countries.objects.countries1);
		let projection = geoCylindricalStereographic()
			.fitSize([width, height], mapData)
			.rotate([-11, 0]); //Adjust size of map
		let path = d3.geoPath().projection(projection);
		let max = d3.max(data.data, (o) => o.value);
		let scheme;
		if (max < 3) {
			scheme = [d3.schemeBlues[3][0], d3.schemeBlues[3][2]];
		} else if (max >= 3 && max <= 9) {
			scheme = d3.schemeBlues[max];
		} else {
			scheme = d3.schemeBlues[9];
		}
		const color = d3.scaleQuantize([0, max], scheme);

		setColorBands({ color: color });

		let mapGroup = svg.select("g.mapGroup");
		mapGroup = mapGroup.empty()
			? svg.append("g").attr("class", "mapGroup")
			: mapGroup;

		mapGroup
			.selectAll("path")
			.data(mapData.features)
			.join("path")
			.attr("fill", (d) => {
				let data = groupedData[d.id];
				return color(data ? data[0].value : 0);
			})
			.attr("d", (d) => {
				return path(d);
			});
		appendOnce(svg, "path.mapBoundaries")
			.datum(topojson.mesh(countries))
			.attr("fill", "none")
			.attr("stroke", "#000055")
			.attr("stroke-linejoin", "round")
			.attr("d", path);
	}, [data]);
	let colors = colorBands ? colorBands.color.range() : null;
	let colorThresholds = colorBands ? colorBands.color.thresholds() : null;
	return (
		<div className={"choropleth"}>
			<h3 className={"choropleth__title"}>{data.title}</h3>
			<div className={"choropleth__graph-container"}>
				<svg
					className={"choropleth__graph"}
					viewBox={`0 0 ${width} ${height}`}
					ref={svgRef}
				/>
				{colors && (
					<div
						className={"choropleth__legend"}
						style={{ "--grid-width": colors.length }}>
						{colors.map((color, i) => {
							let content;
							if (i === 0) {
								content = `< ${Math.round(colorThresholds[i])}`;
							} else if (i === colors.length - 1) {
								content = `>= ${Math.round(colorThresholds[i - 1])}`;
							} else {
								content = `${Math.round(colorThresholds[i - 1])} - ${Math.round(
									colorThresholds[i]
								)}`;
							}
							return (
								<div key={color} className={"choropleth__legend-item"}>
									<div
										className={"choropleth__legend-color"}
										style={{
											"--color": color,
										}}
									/>
									<div className={"choropleth__legend-label"}>{content}</div>
								</div>
							);
						})}
					</div>
				)}
			</div>
		</div>
	);
}
